import { css, html, LitElement } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { sharedStyles } from "../../styles/shared";
import { property } from "lit/decorators/property.js";
import { when } from "lit/directives/when.js";
import "../../atoms/title";
import "../../atoms/text";

@customElement("bs-landing-title-header")
export class BsLandingTitleHeader extends LitElement {
	static get styles() {
		return [
			sharedStyles,
			css`
				:host {
					display: block;
					text-align: center;
				}

				:host([margin]) {
					margin-bottom: var(--space-l);
				}

				#label {
					text-transform: uppercase;
				}

				#headline {
					max-width: 600px;
					margin: 0 auto;
				}
			`
		];
	}

	@property({ type: String }) headline?: string;
	@property({ type: String }) label?: string;
	@property({ type: Boolean, reflect: true }) margin = false;

	render() {
		const { headline, label } = this;
		return html`
			${when(label, () => html`<bs-text id="label" label>${label}</bs-text>`)}
			${when(headline, () => html`<bs-title id="headline" size="huge">${headline}</bs-title>`)}
		`;
	}
}
